import { Routes } from '@angular/router';

export const adsCampaignsSettingsChildRoutes: Routes = [
  {
    path: '',
    children: [
      { path: '', redirectTo: 'overview', pathMatch: 'full' },
      {
        path: 'overview',
        loadComponent: () =>
          import('./components/campaign-settings/campaign-overview/campaign-overview.component').then((m) => m.CampaignOverviewComponent),
      },
      {
        path: 'videos-presence',
        loadComponent: () =>
          import('./components/campaign-settings/campaign-video-presence/campaign-video-presence.component').then(
            (m) => m.CampaignVideoPresenceComponent,
          ),
      },
      {
        path: 'statistics',
        loadComponent: () =>
          import('./components/campaign-settings/campaign-statistics/campaign-statistics.component').then(
            (m) => m.CampaignStatisticsComponent,
          ),
      },
    ],
  },
];
